
import { IRecentEmploymentDetailsState } from './state';
import { createReducer, on, State, Action } from '@ngrx/store';
import {
  onNgrxForms, onNgrxFormsAction, SetValueAction
} from 'ngrx-forms';
import { ResponseAction } from './actions';
import { RecentEmploymentDetailsModel } from 'src/app/model/recent-employment-details.model';

export const state: IRecentEmploymentDetailsState = {
  employer:  Array<RecentEmploymentDetailsModel>(),
};

const reducer = createReducer(state,
  onNgrxForms(),
  onNgrxFormsAction(SetValueAction, (state, action) => {
    return state;
  }),
  on(ResponseAction, (state, { payload }) => {

    return {
      ...state,
      employer: payload
    };
  })
);

export function recentEmploymentDetailsReducer(state: any | undefined, action: Action) {
  return reducer(state, action);
}
